// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

const host = 'http://localhost:4200';

// Set the below to your IP and also start your local server with your IP in the line below to test on local network devices
// ng serve --port 4200 --host 10.110.64.50:4200 --proxy-config proxy.conf.json
// Or, follow http://tattoocoder.com/angular-cli-using-the-environment-option/ 
// and start with something like
// ng serve --port 4200 --host 10.110.64.50 --env=as --proxy-config proxy.conf.json
// Do not check the below line in:
// const host = 'http://10.110.64.50:4200'

export const environment = {
  production: false,
  host: host
};
